<template>
  <RouterLink to="/" class="mr-4">
    <div id="panel-brand" class="title white--text">
      E-Commerge&nbsp;
      <span class="font-weight-light">Panel</span>
    </div>
  </RouterLink>
</template>

<script>
export default {
  name: "PanelBrand"
};
</script>

<style>
#panel-brand {
  line-height: normal;
}
</style>